var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "assist-panel-fade" } }, [
    _vm.isVisible
      ? _c(
          "div",
          {
            staticClass: "assist-panel",
            class: { "assist-panel--resizing": _vm.isResizing },
            style: { width: `${_vm.panelWidth}px` },
          },
          [
            _c("div", {
              staticClass: "assist-panel__resize-handle",
              attrs: {
                role: "separator",
                "aria-orientation": "vertical",
                "aria-valuenow": _vm.panelWidth,
                "aria-valuemin": _vm.minPanelWidth,
                "aria-valuemax": _vm.maxPanelWidth,
                "aria-label": _vm.$t("assist.resizeHandleAriaLabel"),
                tabindex: "0",
              },
              on: {
                pointerdown: _vm.onResizeStart,
                pointermove: _vm.onResizeMove,
                pointerup: _vm.onResizeEnd,
                pointercancel: _vm.onResizeEnd,
                keydown: _vm.onResizeKeydown,
              },
            }),
            _c(
              "div",
              { staticClass: "assist-panel__header" },
              [
                _c("TabNavigation", {
                  attrs: { "active-tab": _vm.activeTab },
                  on: { "tab-change": _vm.handleTabChange },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "assist-panel__content" },
              [
                _c(
                  _vm.currentContentComponent,
                  _vm._b(
                    {
                      tag: "component",
                      on: {
                        "suggestion-click": _vm.handleSuggestionClick,
                        "confirm-selection": _vm.handleConfirmSelection,
                        "manuscript-select": _vm.handleManuscriptSelect,
                        "manuscripts-loaded": _vm.handleManuscriptsLoaded,
                        "manuscripts-error": _vm.handleManuscriptsError,
                        "back-to-request": _vm.handleBackToRequest,
                        "back-click": _vm.handleBackToRequest,
                      },
                    },
                    "component",
                    _vm.currentContentProps,
                    false
                  )
                ),
              ],
              1
            ),
            _vm.hasAnyError
              ? _c("div", { staticClass: "assist-panel__error" }, [
                  _c("div", { staticClass: "error-content" }, [
                    _c("span", { staticClass: "error-icon" }, [_vm._v("⚠️")]),
                    _c("div", { staticClass: "error-messages" }, [
                      _vm.error
                        ? _c("p", { staticClass: "error-message" }, [
                            _vm._v(_vm._s(_vm.error)),
                          ])
                        : _vm._e(),
                      _vm.apiError
                        ? _c("p", { staticClass: "api-error-message" }, [
                            _vm._v("API: " + _vm._s(_vm.apiError)),
                          ])
                        : _vm._e(),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "error-dismiss",
                        on: { click: _vm.dismissErrors },
                      },
                      [_vm._v("×")]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.isAnyLoading
              ? _c("div", { staticClass: "assist-panel__loading-overlay" }, [
                  _c("div", { staticClass: "loading-content" }, [
                    _c("div", { staticClass: "loading-spinner" }),
                    _c("p", [_vm._v("処理中...")]),
                  ]),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "assist-panel__footer" },
              [_c("FishCounter")],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }